// Sidebar Text
const Hide_Menu_text = "Hide Menu";
const Open_Menu_text = "Open Menu";

//Add_faqs page:
const add_faqs_text = {
  Related_Question: "Related Question",
  Question: "Question",
  Enter_question: "Enter Question",
  save_changesDynamic_toast_error:
    "Failed to connect to the server. Please try again later.",
  _changesDynamic_toast_success: "Data saved successfully",
  Answer: "Answer",
  Enter_answer: "Enter Answer",
  options_search_value1: "Reservation",
  options_search_value2: "Table Setup",
};

//Add_SearchMaster page:
const Add_SearchMaster_text = {
  Name_heading: "Name",
  Name_inside_inputField: "Enter Master Name",
  Value_heding: "Value",
  value_inside_inputfield: "Enter Master Value",
  URl_heading: "URL",
  URL_inside_input_filed: "Enter Master URL",
};

//Dashboard Page
const sidebarpagetext = {
  Dashborard_text: "Dashboard",
  Analytics_text: "Analytics",
  Rsrvtn_Mngmnt_text: "Reservation Mngmt",
  Guest_Mgmt_text: "Enquiry Mngmt",
  Staff_Mgmt_text: "Staff Mngmt",
  Setting_text: "System Settings",
  Website_Mngmt: "Website Mngmt",
  Report_text: "Report",
  Restaurant_Setup_text: "Restaurant Setup",
  Feedback_Mngmt: "Feedback Mngmt",
  Help_Support_text: "Help and Support",
  Feedback_management_text: "Feedback Mngmt",
};
//Profile_Settings Page
const ProfileSettingPage = {
  Update: "Update",
};

// Add Staff Page Text
const AddStaffPageText = {
  Add_Staff: "Add Staff",
  Personal_Details: "Personal Details",
  Personal_id_no: "State Identity Number*",
  Coordinatory_no: "Driving Licence Number",
  Employee_Details: "Employee Details",
  Placeholder_Name: "Staff Full Name*",
  Add_Email: "Email*",
  Phone_Number: "Phone Number*",
  Alt_Phone_Number: "Alt. Phone Number",
  Permanent_Address: "Permanent Address*",
  PesonalID_text: "Doesn’t  have  State Identity Number",
  User_Id_text: "This  email is for signing in to your account.",
  Img_alert: "Maximum size 500kb.",
  D_O_B: " Date of Birth*",
  Select_Designation: "Select Designation",
  Add_Image: "Add Image",
  Image_Validation: "Min. size 200kb",
  Image_Validation2: "Max. size 500kb",
  Gender_text: "Gender*",
  Blood_Group: "Enter Your Blood Group",
  Select_Blood_Group: "Select Blood Group",
  Search_City: "Search City",
  Permanent_addressplaceholder: "Enter a location",
  State: "State",
  City_Name: "City Name",
  Country: "Country",
  Enter_State: "Enter State",
  Enter_Country: "Enter Country",
  websiet_res_timing: "Website Shop Timings",
  Social_media_text: "Social Media Links",
  facebook_link: "Enter Your Facebook Link",
  linkedin_link: "Enter Your Youtube Link",
  twitter_link: "Enter Your Twitter Link",
  snapchat_link: "Enter Your Snapchat Link",
  instagram_link: "Enter Your Instagram Link",
  Temporary_Address: "  Temporary Address",
  Same_Address: "  Same As Permanent Address",
  join_date: "Joining Date*",
  Designation: "Designation*",
  password_text: "Enter a Password",
  password_text2: "Re-Enter Password",
  Create_pass: "Create Password*",
  Confirm_pass: "Confirm Password*",
  save_text: "Save",
  update_text: "Update",
  update_staff: "Update Staff",
  cencel_text: "Cancel",
  password_detail: "Password",
};

// View Staff Page Text
const ViewStaffPagesText = {
  View_Staff: "View  Staff",
  Contact_Details: "Contact Details",
  Start_Date: "Start Date",
  End_Date: "End Date",
  Close_text: "Cancel",
  Search_Employee: "Search Employee",
  Search_Employee_reservation: "Search",
  Search_text: "Search",
  Staff_Filter: "Employee Filter",
  Staff_Filter_reservation: "Search",
  Add_Employee: "Add Staff",
  Send_Email: "Send Email",
  D_O_B: AddStaffPageText.D_O_B,
  City_Name: AddStaffPageText.City_Name,
  Personal_Details: AddStaffPageText.Personal_Details,
  Employee_Details: AddStaffPageText.Employee_Details,
  model_text: " Are you Sure You want to",
};
//login page
const loginPagesText = {
  barleys: "Barley's",
  tagLineLogin: "The most popular Restaurant in Sweden",
  gotoWebBtn: "Go to website",
  login: "Login",
  forgotPassword: "Forgot your password?",
  logingetstarted: "Log in to Get Started",
  rememberMe: "Remember me",
  forgotPass: "Forgot Password",
};

//Forgot page array variables
const ForgotPagesText = {
  barleys: loginPagesText.barleys,
  tagLineLogin: loginPagesText.tagLineLogin,
  gotoWebBtn: loginPagesText.gotoWebBtn,
  login: loginPagesText.login,
  forgotPassword: loginPagesText.forgotPassword,
  forgotPasswordText:
    "Don’t worry, happens to all of us. Enter your email below to recover your password",
  didntReceive: "Didn’t receive a Verification link?",
  resend: "Resend",
  sendLink: "Send Verification Link",
};

//Forgot page array variables
const ChangePasswordPagesText = {
  barleys: loginPagesText.barleys,
  tagLineLogin: loginPagesText.tagLineLogin,
  gotoWebBtn: loginPagesText.gotoWebBtn,
  continueLogin: "Continue Login",
  passwordChanged: "Password Changed",
  passChangeSuccess: "Your Password has been Changed Successfully. ",
  changePassword: "Set a password",
  changePasswordText:
    "Your previous password has been reseted. Please set a new password for your account.",
  createPassword: "Create Password",
  create_new_password: "Enter a new Password",
  confirm_new_password: AddStaffPageText.password_text2,
};

// Guest Management page
const GuestManagementPageText = {
  Guest_Management: "Enquiry Management",
  Guest_Filter: "Search",
  Search_Guest: "Search ",
  Search_text: ViewStaffPagesText.Search_text,
  Start_Date: ViewStaffPagesText.Start_Date,
  End_Date: ViewStaffPagesText.End_Date,
  Guest_Name: "Guest Name",
  D_O_B: AddStaffPageText.D_O_B,
  Contact_Details: "Contact Details",
  Email_ID: "Email Id",
  Booking_text: "Message",
  Send_Email: "Send Email",
  Purpose: "Driving License",
};
//View staff right page
const ViewStaffRightPages = {
  Staff_Rights: "Staff Rights",
  Right_Name: "Right Name",
  Smith_John: "Smith John",
  URL_ID_text: "URL/ID",
  Status_text: "Status",
  Action_text: "Action",
  email_text: " xyz@gmail.com",
  Mobile_text: " No.: 7987220910",
  Sub_Rights: "Sub Rights",
  InsidePage_Rights: "Inside Page Rights",
  Add_Btn: "Add Staff Rights",
};
//View sub right page
const ViewSubRightPages = {
  Staff_Sub_Rights: "Staff Sub Rights",
  Staff_Rights: ViewStaffRightPages.Staff_Rights,
  Right_Name: ViewStaffRightPages.Right_Name,
  Smith_John: ViewStaffRightPages.Smith_John,
  URL_ID_text: ViewStaffRightPages.URL_ID_text,
  Status_text: ViewStaffRightPages.Status_text,
  Action_text: ViewStaffRightPages.Action_text,
  email_text: ViewStaffRightPages.email_text,
  Mobile_text: ViewStaffRightPages.Mobile_text,
  InsidePage_Rights: ViewStaffRightPages.InsidePage_Rights,
  Add_Btn: "Add Sub Rights",
};
//Inside page Right
const insidePageText = {
  Inside_Page_R: "Inside Page Rights",
  Staff_Rights: ViewStaffRightPages.Staff_Rights,
  Right_Name: ViewStaffRightPages.Right_Name,
  URL_ID_text: ViewStaffRightPages.URL_ID_text,
  Status_text: ViewStaffRightPages.Status_text,
  Action_text: ViewStaffRightPages.Action_text,
  Smith_John: ViewStaffRightPages.Smith_John,
  Mobile_text: ViewStaffRightPages.Mobile_text,
  email_text: ViewStaffRightPages.email_text,
  Add_Btn: "Add Inside Page Rights",
};
//Create create Inside Page
const createInsidePageText = {
  Create_Inside_R: "Create Inside Page Rights",
  Staff_Rights: "Create Staff Rights",
  Right_Name: ViewStaffRightPages.Right_Name,
  Right_Id: " Right Id",
  create_Text: "Create",
};
//Create Create Staff Right Page
const CreateStaffRightText = {
  Create_text: createInsidePageText.create_Text,
  save_bttn: AddStaffPageText.save_text,
  Staff_Rights: createInsidePageText.Staff_Rights,
  Right_Name: createInsidePageText.Right_Name,
  Right_Type: " Right Type",
  Page_URL: " Page URL",
  create_Text: createInsidePageText.create_Text,
  Select_Right_Type: " Select Right Type",
};
//Edit Staff Page
const EditStaffPage = {
  Staff_Rights: "Edit Staff Rights",
  Right_Name: createInsidePageText.Right_Name,
  Page_URL: CreateStaffRightText.Page_URL,
  save_text: "Update",
}; //Edit sub right page
const EditSubRight = {
  edit_sub_right: ">Edit Staff Sub Rights",
  Staff_Rights: EditStaffPage.Staff_Rights,
  Right_Name: createInsidePageText.Right_Name,
  Right_Id: createInsidePageText.Right_Id,
  save_text: EditStaffPage.save_text,
};
//View sub right page
const ViewDesignationData = {
  viewdesignation_data: "View Designation",
  Entry_date: "Entry Date",
  Designation_Name: "Designation Name",
  Action_text: ViewStaffRightPages.Action_text,
  Add_Btn: "Add Designation",
};

//Add_designation page:
const Add_designation_text = {
  success_message_toast_handleSaveChangesDyamic:
    add_faqs_text.save_changesDynamic_toast_success,
  error_message_toast_handleSaveChangesDyanamic:
    add_faqs_text.save_changesDynamic_toast_error,
  button_text: "Add Staff Rights",
  Designation_name: ViewDesignationData.Designation_Name,
  select_staff_rights: "Select Staff Rights",
  Add_designation: "Add Designation",
};

/**show dropdown  */
const options_search = [
  { value: "Name", label: "Name" },
  { value: "Email", label: "Email" },
  { value: "Mobile No.", label: "Mobile No." },
];
const options_search_car = [
  { value: "Name", label: "Car Name" },
  { value: "Number", label: "Car No." },
  // { value: "Mobile No.", label: "Mobile No." },
];

const options_search2 = [
  { value: "Vehicle Number", label: "Vehicle Number" },
  { value: "LP", label: "LP" },
  { value: "VIN", label: "VIN" },
];
const status_search = [
  { value: "20", label: "All" },
  { value: "0", label: "New" },
  { value: "1", label: "InProgress" },
  { value: "3", label: "Ready For PickUp" },
  { value: "4", label: "OnGoing" },
  { value: "5", label: "Completed" },
  { value: "40", label: "Aggrement Signed" },
  { value: "30", label: "Aggrement Not Signed" },
  { value: "10", label: "Rejected" },
];

const status_search2 = [
  { value: "All", label: "All" },
  { value: "Today", label: "Today" },
  { value: "Upcoming", label: "Upcoming" },
  { value: "Overdue", label: "Overdue" },
];
//options gender
const options_gender = [
  { value: "Male", label: "MALE" },
  { value: "Female", label: "FEMALE" },
  { value: "Other", label: "OTHER" },
  { value: "Not Prefer to say", label: "NOT PREFER TO SAY" },
];
//options options blood group
const options_blood_group = [
  { value: "A Positive(A+)", label: "A Positive(A+)" },
  { value: "A Negative(A-)", label: "A Negative(A-)" },
  { value: "B Positive(B+)", label: "B Positive(B+)" },
  { value: "B Negative(B-)", label: "B Negative(B-)" },
  { value: "AB Positive(AB+)", label: "AB Positive(AB+)" },
  { value: "AB Negative(AB-)", label: "AB Negative(AB-)" },
  { value: "O Positive(O+)", label: "O Positive(O+)" },
  { value: "O Negative(O-)", label: "O Negative(O-)" },
  { value: "Other", label: "Other" },
];

//options options blood group
const options_select_drop_feedback = [
  { value: "all", label: "All", datepicker_show: false },
  { value: "today", label: "Today", datepicker_show: false },
  { value: "last_7_days", label: "Last 7 Days", datepicker_show: false },
  { value: "this_month", label: "This Month", datepicker_show: false },
  { value: "last_month", label: "Last Month", datepicker_show: false },
  { value: "this_year", label: "This Year", datepicker_show: false },
  {
    value: "date",
    label: "Select Date Range",
    datepicker_show: true,
  },
];
//options options blood group
const options_select_report = [
  { value: "All", label: "All" },
  { value: "Cash", label: "Cash" },
  { value: "Card", label: "Card" },
  { value: "Reservation", label: "Walk-in" },
  { value: "Online Cover", label: "Online Cover" },
  // { value: "Offline Cover", label: "Offline Cover" },
  // { value: "Food", label: "Food" },
  // { value: "Alcohal", label: "Alcohal" },
  // { value: "Takeaway", label: "Takeaway" },
  // { value: "Online Order", label: "Online Order" },
];

//options options blood group
const options_select_report_sales = [
  { value: "All", label: "All" },
  { value: "less_then", label: "Person Less Then 8" },
  { value: "greater_then", label: "Person Greater Then 8" },
  // { value: "no_show", label: "No Show" },
  { value: "Online", label: "Online" },
  { value: "Offline ", label: "Offline" },
];

//options options blood group
const options_select_report_guest = [
  { value: "All", label: "All" },
  { value: "vip", label: "VIP" },
  { value: "less_then", label: "Reservation below 8" },
  { value: "greater_then", label: "Reservation Above 8" },
];

//Floor Plan Management Page
const FloorPlanMngmntPage = {
  Floor_Management: "Floor Management",
  Create_Dining_Area: "Create Dining Area",
  Name: "Name",
  Type: "Type",
  Tables: "Tables",
  Restaurant: "Restaurant",
  Inside: "Inside",
  table_data_num: "38",
  Edit: "Edit",
  Delete: "Delete",
};
//Create Floor Plan Page
const CreateFloorPlanPage = {
  Create_Dining: "Create a Dining Area",
  Edit_Dining_Area: "Edit a Dining Area",
};
//Edit FLoor PLan Page
const EditFloorPlanPage = {
  Edit_Dining_Area: "Edit a Dining Area",
};
//changePassward
const changePasswardPage = {
  Error_massage:
    "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and should be 8 characters long.",
};
const create_restaurants = {
  Restaurant_details: "Restaurant Details",
  Restaurant_name: "Restaurant Name *",
  Restaurant_tag_line: "Restaurant Tag line *",
  conatct_person_details: "Contact Person Details ",
};

// AddImage text page :
const AddImage_text = {
  copy_link: "Copy Link",
  drop_img_text: "Drop Your Image Here",
  choose_img_txt: "Choose Image",
  save_text: AddStaffPageText.save_text,
  want_to_dlt_text: "Do You Want to Delete This Data?",
  yes_text: "Yes",
  No_text: "No",
};

//AddKB text
const AddKB_text = {
  topic_name: "Topic Name",
  details: "Details",
};

//AllotcateArea text section
const AllotcateArea_text = {
  filters_text: "FILTERS",
  to_confirm: "To Confirm",
  Current: "Current",
  Arrived: "Arrived",
  No_show: "No Show",
  confirm: "Confirm",
  accept: "Accept",
  Select_Table: "Select Table",
  release: "Release",
  decline: "Decline",
};

//Analytics page text
const Analytics_text = {
  overlay_text_netcovers: "NETCOVERS",
  overlay_text_covers: "ONLINE COVERS",
  overlay_text_direct_booking: "DIRECT RESRV.",
  overlay_text_aggregator: "AGGREGATOR",
  download_text: "Download",
  overlay_text_covers_off: "OFFLINE COVERS",
  walk_in: "WALK -IN",
  reservation_text: "RESERVATION",
  total_reservation: "Total Reservation",
  arrival_txt: "Arrival",
  complete_txt: "Complete",
  Approval_Pending: "Approval Pending",
  revenue: "Revenue",
  Cancellations: "Cancellations",
  No_Show: AllotcateArea_text.No_show,
  no_of_pets: "No. of Pets",
  Direct_Website: "Direct Website",
  Special_Day_Booking: "Special Day Reservation",
  Dispute: "Dispute",
  Date_Month: "Date/Month",
  hour: "Hour",
  Total_Revenue: "Total Revenue",
  Total_Booking: "Total Reservation",
  Auto_Approval: "Auto Approval",
  Period_text: "Period",
  Search_text: "Search",
  decline_text: "Declined",
  Manual_Approval: "Manual Approval",
  Rate_of_Auto_Approval: "Rate of Auto Approval",
  arrived: AllotcateArea_text.Arrived,
  Completed_text: "Completed",
  Cancelled_text: "Cancelled",
  no_show: AllotcateArea_text.No_show,
  reservation_text_2: "Reservation",
  s_no: "Sr.No.",
  guest_name: GuestManagementPageText.Guest_Name,
  Email_txt: "Email",
  mobile_no: "Mobile No.",
  Reservation_Date_Time: "Reservation Date/Time",
  Person_Child_Pets: "Person | Child | Pets",
  Bill_Amount: "Bill Amount",
  Previous_text: "Previous",
  next_text: "Next",
};

//BlogWebsite page
const BlogWebsite_text = {
  Add_Blog: "Add Blog",
  Create_Date: " Create Date",
  Description: "Description",
  Keywords: "Keywords",
  Image: "Image",
  Title: "Title",
  save_txt: AddStaffPageText.save_text,
  no_txt: AddImage_text.No_text,
  Yes_txt: AddImage_text.yes_text,
};

//CapsWebsite page
const CapsWebsite_text = {
  Beer_Cap: "Beer Cap ",
  Add_beer_cap: "Add Beer Cap ",
  Add_New_Beer_Cap: "Add New Beer Cap",
  Drop_Your_Image_Here: "Drop Your Image Here",
  chose_img: AddImage_text.choose_img_txt,
  dlt_text: "Do You Want to Delete This Data?",
  n_text: AddImage_text.No_text,
  y_text: AddImage_text.yes_text,
};

export {
  add_faqs_text,
  Add_SearchMaster_text,
  Add_designation_text,
  AddImage_text,
  AddKB_text,
  AllotcateArea_text,
  Analytics_text,
  BlogWebsite_text,
  CapsWebsite_text,
  ProfileSettingPage,
  changePasswardPage,
  EditFloorPlanPage,
  CreateFloorPlanPage,
  FloorPlanMngmntPage,
  EditSubRight,
  EditStaffPage,
  CreateStaffRightText,
  createInsidePageText,
  insidePageText,
  ViewSubRightPages,
  ViewStaffRightPages,
  GuestManagementPageText,
  AddStaffPageText,
  ViewStaffPagesText,
  Open_Menu_text,
  Hide_Menu_text,
  sidebarpagetext,
  ForgotPagesText,
  loginPagesText,
  ChangePasswordPagesText,
  options_search,
  status_search,
  options_gender,
  options_blood_group,
  create_restaurants,
  ViewDesignationData,
  options_select_drop_feedback,
  options_select_report,
  options_select_report_sales,
  options_select_report_guest,
  options_search2,
  status_search2,
  options_search_car
};
